import { Builder } from '@builder.io/sdk';
import { ContactCTA } from './ContactCTA';

const ContactCTAConfig = {
  name: 'ContactCTA',
  friendlyName: 'Contact CTA',
  inputs: [
    {
      name: 'title',
      type: 'string',
      required: true,
    },
    {
      name: 'subtitle',
      type: 'string',
    },
    {
      name: 'buttonText',
      type: 'string',
      required: true,
    },
    {
      name: 'buttonUrl',
      type: 'string',
      required: true,
    },
    {
      name: 'image',
      type: 'file',
      defaultValue: '',
    },
    {
      name: 'imageFit',
      type: 'string',
      enum: ['cover', 'contain'],
      defaultValue: 'cover',
    },
    {
      name: 'imagePosition',
      type: 'string',
      enum: ['left', 'right'],
      defaultValue: 'left',
    },
  ],
};

Builder.registerComponent(ContactCTA, ContactCTAConfig);
